import axios from 'axios';
import { setupCache } from 'axios-cache-interceptor';
import { domain } from 'config';
import { getToken } from 'firebaseUtil';
import { store } from 'store';
import { setErrorType } from 'store/reducers/error';

// const instance = Axios.create();
// const axios = setupCache(instance);

// Add a request interceptor
axios.interceptors.request.use(
  async function (config) {
    // Do something before request is sent
    const accessToken = await getToken();
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    config.baseURL = domain;

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

const FORBIDDEN_MESSAGE = 'You do not have permission to make this change. Please contact an administrator if you need access.';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const method = error?.config?.method?.toLowerCase();
    if (error?.response?.status === 403 && method && method !== 'get') {
      // keep any page-level catch that reads response.data.detail showing the same message
      const data = error.response.data;
      error.response.data = { ...(data && typeof data === 'object' ? data : {}), detail: FORBIDDEN_MESSAGE };
      store.dispatch(setErrorType({ errorType: { message: FORBIDDEN_MESSAGE, severity: 'error', duration: 10000 } }));
    }
    return Promise.reject(error);
  }
);

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  patch: axios.patch
};
